import { render, staticRenderFns } from "./material-desc.vue?vue&type=template&id=4117beb8"
import script from "./material-desc.vue?vue&type=script&lang=js"
export * from "./material-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports